"use client";
import React, { useEffect, useState } from "react";
import UserContext from "./userContext";
import Cookies from 'js-cookie';

const UserProvider = ({ children }) => {
  const [user, setUser] = useState(undefined);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    async function fetchUser() {
      try {
        const token = Cookies.get('token');
        if (token) {
          const base64DecodedData = atob(localStorage.getItem("sessiondata"));
          const tempUser = JSON.parse(base64DecodedData);
          setUser({ ...tempUser['user']});
          setIsAuthenticated(true);
        } else {
          setUser(undefined);
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error('Error fetching user:', error);
        setUser(undefined);
        setIsAuthenticated(false);
        // Clear invalid session data
        localStorage.removeItem('sessiondata');
        Cookies.remove('token');
      }
    }
    fetchUser();
  }, []);

  const login = (userData, token) => {
    setUser(userData);
    setIsAuthenticated(true);
  };

  const logout = () => {
    setUser(undefined);
    setIsAuthenticated(false);
    localStorage.removeItem('sessiondata');
    Cookies.remove('token');
  };

  const validateToken = () => {
    const token = Cookies.get('token');
    if (!token) {
      logout();
      return false;
    }
    return true;
  };

  return (
    <UserContext.Provider value={{ 
      user, 
      setUser, 
      isAuthenticated, 
      setIsAuthenticated, 
      login, 
      logout,
      validateToken
    }}>
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;